<div class="padding-20" *ngIf="user">
  <div class="display-flex">
    <div class="flex-align-self-center">
      <span class="circle--initials circle--initials-lg" [ngStyle]="getRandomColor(name_initials)">
        {{ name_initials | uppercase }}
      </span>
    </div>
    <div class="padding-right-3 flex-align-self-center">
      <div>
        <h1 class="header-name-display">
          {{ user?.fullName }}
          <span class="text-primary" *ngIf="user?.isIdentityVerified">
            <usa-stacked-icon [size]="'sm'">
              <usa-icon class="usa-stack-icon font-sans-md" [icon]="'shield'"></usa-icon>
              <usa-icon class="usa-stack-icon font-sans-sm" [icon]="'check'"></usa-icon>
            </usa-stacked-icon>
          </span>
        </h1>
      </div>
      <div class="margin-top-neg-2px text-semibold" *ngIf="user?.isGov">
        <span>{{hierarchy?.agency}}</span>
      </div>
    </div>
  </div>
  <br />
  <hr />
</div>
